import { isCommonAssetRequest, type RequestHandler } from 'msw';

import { worker } from './browser';

const API_PREFIX = '/api/';

export async function startDevMswWorker(handlers: readonly RequestHandler[]): Promise<void> {
  worker.use(...handlers);

  await worker.start({
    onUnhandledRequest(request, print) {
      const { pathname } = new URL(request.url);

      if (isCommonAssetRequest(request) || !pathname.startsWith(API_PREFIX)) {
        return;
      }

      print.warning();
    },
    serviceWorker: { url: '/mockServiceWorker.js' },
  });
}
